export type ChannelsPageView = 'table' | 'empty';

/**
 * What the Channels page draws below its header: the table, or the empty state
 * once the channels are KNOWN to be none. `botPypes` is `null` until the first
 * load (and after a solution switch), and that is not "no channels" — the empty
 * state would flash while the request is in flight — so it keeps the table,
 * as the page did before.
 */
export const resolveChannelsPageView = ({
  botPypes,
  channelCount,
}: {
  botPypes: readonly unknown[] | null | undefined;
  channelCount: number;
}): ChannelsPageView => (botPypes && channelCount === 0 ? 'empty' : 'table');
